import React from 'react'
import { Loader } from '@common/ui'
import { com } from '@eidu/web'
import DraftFieldValue from '../../domain/entity/DraftFieldValue'
import TrimmedTextInput from './TrimmedTextInput'
import Field = com.eidu.entity.field.Field

export type EntityFormTextInputProps = {
  field: Field
  fieldValue: DraftFieldValue | undefined
  updateField: (value: DraftFieldValue) => void
  error: boolean
  loading?: boolean
  disabled?: boolean
}

const EntityFormTextInput = ({
  field,
  fieldValue,
  updateField,
  error,
  loading = false,
  disabled = false,
}: EntityFormTextInputProps) => (
  <TrimmedTextInput
    key={`field-${field.id.toString()}`}
    required={field.required}
    label={field.name}
    value={fieldValue?.value ?? ''}
    onChange={(event) => updateField({ fieldId: field.id, type: field.type, value: event.target.value })}
    error={error}
    disabled={disabled || loading}
    placeholder={loading ? ' ' : undefined}
    rightSection={loading ? <Loader size="xs" /> : undefined}
  />
)

export default EntityFormTextInput
